<template>
  <ftw-system-bar :messages="systemMessages" item-icon="type.icon" @dismiss="dismissMessage" />
</template>

<script>
import { join } from 'path'
import { api } from '@/api'
import { createLink } from '@/api/helpers'

export default {
  name: 'MeetingSystemBar',
  data() {
    return {
      systemMessages: [],
    }
  },
  async created() {
    await this.fetchActiveInfos()
  },
  methods: {
    async fetchActiveInfos() {
      const response = await api.get(createLink('system_message'), {
        params: { active: true, dismissed: false },
      })
      this.systemMessages = response.data
    },
    dismissMessage(message) {
      api.patch(createLink(join('system_message', message.id.toString(), 'dismiss')))
    },
  },
}
</script>
